import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { GlobalComponent } from "src/app/global-component";
import { NotificationType } from "src/app/core/enums/notification-type-enum";


export class NotificationExtendedListLayoutConfig extends TableConfigurationModel {

     constructor() {
        super();
        this.listTitle = "Notification List";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {
                dataFieldName: 'subject',
                title: 'Subject',
                sortable: new SortByValuesModel(),
                visible: 'true',
                order: 1,
                width: "800px",
                type: ColumnTypeEnum.String,
            },

            {
                dataFieldName: 'modifiedDate',
                title: 'Modified Date',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 2,
                width: "150px",
                type: ColumnTypeEnum.Date
            },
            {
                dataFieldName: 'isRead',
                title: 'Status',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 3,
                width: "100px",
                type: ColumnTypeEnum.StatusCustom,
                customStatusClass: {
                    type: Boolean,
                    switchOptions: [
                        { case: true, return: 'coloredTextArea purple' },
                        { case: false, return: 'coloredTextArea blue' },
                        { case: undefined, return: 'coloredTextArea orange' }
                    ]
                },
                customStatusText: {
                    type: Boolean,
                    switchOptions: [
                        { case: true, return: 'Read' },
                        { case: false, return: 'Unread' },
                        { case: undefined, return: 'Other' }
                    ]
                }
            },

            {
                title: 'Actions',
                visible: 'true',
                order: 4,
                width: "140px",
                type: ColumnTypeEnum.Action
            },
        ]

        this.searchbarFilter =
        {
            value: '',
            placeHolderText: "Search by notifications name"
        }
        this.filters = [
            {
                label: "SelectStatus",
                options: [
                    new NgSelectListModel(undefined, $localize`:@@:Select Status`, undefined, undefined, true),
                    new NgSelectListModel(true, $localize`:@@:Read`, undefined, undefined),
                    new NgSelectListModel(false, $localize`:@@:Unread`, undefined, undefined),

                ],
                selectedOption: undefined,
                inDropdown: true,
                inHeading: false,
                inButton: false,
            },
            {
                label: "SelectTypes",
                options: [
                    new NgSelectListModel(undefined, $localize`:@@:Select Type`, undefined, undefined, true),
                    new NgSelectListModel(NotificationType.Message, $localize`:@@:Messages`, undefined, undefined),
                    new NgSelectListModel(NotificationType.SuccessMessage, $localize`:@@:Success Messages`, undefined, undefined),
                    new NgSelectListModel(NotificationType.Warning, $localize`:@@:Warnings`, undefined, undefined),
                    new NgSelectListModel(NotificationType.Alert, $localize`:@@:Alerts`, undefined, undefined),

                ],
                selectedOption: undefined,
                inDropdown: true,
                inHeading: false,
                inButton: false,
            }
        ]
        this.actions = [

            {
                visible: 'true',
                label: 'View',
                actionId: ActionIdEnum.View,
                icon: 'ri-eye-fill',
                inDropdown: true,
                inList: false
            },
            {
                visible: 'true',
                label: 'Mark as Read',
                actionId: ActionIdEnum.Select,
                icon: 'ri-chat-check-line',
                inDropdown: true,
                visibleOnValues: [false],
                dataFieldName: 'isRead',
                inList: false
            },
            {
                visible: 'true',
                label: 'Delete',
                actionId: ActionIdEnum.Delete,
                icon: 'ri-delete-bin-fill',
                inDropdown: true,
                inList: false
            },
        ]
        this.buttons = [
            {
                visible: 'true',
                label: "Mark as Read",
                action: ButtonIdEnum.Enable,
                color: "btn-soft-primary",
                iconIsAfterLabel: true,
                icon: "ri-chat-check-line",
                type: ButtonTypeEnum.CheckBoxSelected,
             
            },
         
            
            {
                visible: 'true',
                label: undefined,
                iconIsAfterLabel: true,
                action: ButtonIdEnum.Delete,
                color: "btn-primary",
                icon: "ri-delete-bin-fill",
                type: ButtonTypeEnum.CheckBoxSelected,
            }


        ]
    }
}